import { Bot } from 'lucide-react';

interface TypingIndicatorProps {
  mode?: 'typing' | 'thinking' | 'processing';
}

export function TypingIndicator({ mode = 'typing' }: TypingIndicatorProps) {
  const messages = {
    typing: "Génération en cours...",
    thinking: "Analyse en cours...",
    processing: "Traitement en cours..."
  };

  return (
    <div className="flex justify-start w-full group">
      <div className="max-w-[85%] md:max-w-[70%] flex flex-col space-y-2 items-start">
        {/* Avatar et nom */}
        <div className="flex items-center space-x-2 px-1">
          <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center">
            <Bot className="h-4 w-4 text-primary-foreground" />
          </div>
          <span className="text-xs font-medium text-muted-foreground">Assistant IA</span>
        </div>

        {/* Bulle de frappe */}
        <div className="bg-card text-card-foreground rounded-2xl rounded-bl-md p-4 shadow-sm border">
          <div className="flex items-center space-x-2">
            <div className="flex space-x-1">
              <div className="w-2 h-2 bg-muted-foreground rounded-full animate-bounce"></div>
              <div className="w-2 h-2 bg-muted-foreground rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
              <div className="w-2 h-2 bg-muted-foreground rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
            </div>
            <span className="text-xs text-muted-foreground">{messages[mode]}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
